"use strict";
import ImageLoader from './intro/image_loader.js';
import EagerLoader from './intro/eager_loader.js';

const $ = require('jquery'),
TweenMax = require('tweenMax')
;

let indexjs = null;

var logSize = function () {
    let s = window.innerWidth + ' x ' + window.innerHeight;
    $('#current-size').html(s);
};
/*
logSize();
$(window).resize(logSize);
*/

var loading = function(d){
    // load svg
    var $app = $('#app');
    var $intro = $('#intro-frame');
    //var $turnHint = $('.turn-screen-hint').hide();
    var svgPromise = new $.Deferred;

    $intro.css({
      // background: '#fff'
    });

    var intervals = [];

    // load intro objects
    var images = [
        {
            url: './assets/imgs/loading-1.svg',
            callback: function(response){
                var svgDOM = response.getElementsByTagName('svg');
                var $svg = $(svgDOM);
                $svg
                .attr({
                    id: 'loading-1',
                    class: 'bg bg-frame',
                })
                .appendTo($intro)
                ;
                $('#intro-frame text').html('<span style="visibility:hidden"> 0</span>0%');
                $('#fire-pre').hide();
                var toggleCracker = function(off_fire, on_fire){
                    $(off_fire).hide();
                    $(on_fire).show();
                };
                $('#fire-2,#fire-3,#fire-4,#fire-5,#fire-6,#fire-7,#fire-8,#fire-9').hide();
                var t = 100;
                var theInterval = setInterval(function(){
                    // setTimeout(toggleCracker.bind(this, '#fire-1', '#fire-2'), 0);
                    // setTimeout(toggleCracker.bind(this, '#fire-2', '#fire-3'), t);
                    // setTimeout(toggleCracker.bind(this, '#fire-3', '#fire-4'), t * 2);
                    // setTimeout(toggleCracker.bind(this, '#fire-4', '#fire-1'), t * 4);
                    for (let i=0; i<8; i++){
                      setTimeout( toggleCracker.bind(this, `#fire-${i+1}`, `#fire-${i+2}`), t * i );
                    }
                    setTimeout(toggleCracker.bind(this, '#fire-9', '#fire-1'), t * 8);
                }, t * 10);
                intervals.push(theInterval);
            }
        },
        {
            url: './assets/imgs/loading-2.svg',
            callback: function(response) {
                var $object = $(response.getElementsByTagName('svg'))
                $object
                .appendTo($intro)
                .attr({
                    id: 'loading-2',
                    class: 'bg bg-frame',
                })
                .hide()
                ;
            }
        }
    ];
    var introLoaderCallback = function() {
    };

    var introLoader = new ImageLoader(images);
    var introPromise = introLoader.promise;

    introPromise.done(introLoaderCallback)

    var svgs = [

    ];

    introPromise.done(function(){
        var images = [
            {
                url: './assets/imgs/mazu_background.svg',
                callback: function(response) {
                    var svg = response.getElementsByTagName('svg');
                    var $svg = $(svg)
                        .attr({
                            type: "image/svg+xml",
                            id: "main-background",
                            class: "bg bg-parade",
                        });
                    svgs.push({
                        target: $app,
                        dom: $svg
                    })
                }
            },
            {
                url: localStorage["mazu_language"] === "en" ?
                      './assets/imgs/english-svg/panel.svg' :
                      './assets/imgs/panel.svg',

                callback: function(response) {
                    var svg = response.getElementsByTagName('svg');
                    var $svg = $(svg)
                        .attr({
                            type: "image/svg+xml",
                            id: localStorage["mazu_language"] === "en" ?
                                  'panel-english' :
                                  'panel',

                            class: "bg bg-parade",
                        });
                    svgs.push({
                        target: $app,
                        dom: $svg
                    })
                }
            },
        ];

        let $main_parade = $('#main-parade');
        let image_prefix = './assets/imgs/parade/';

        const platform =  navigator.platform;

        if (platform.match(/(Linux)|(iPhone)/i)) {
            image_prefix += 'tiny/';
        } else if (platform.match(/(iPad)/i)) {
            image_prefix += 'small/';
        } else if (platform.match(/(Mac)|(Win)/i)) {
            image_prefix += 'normal/';
        } else {
            let size = window.innerWidth * window.innerHeight;

            if (size <= 600 * 600) {
                image_prefix += 'tiny/';
            } else if (size <= 900 * 900) {
                image_prefix += 'small/';
            } else {
                image_prefix += 'normal/';
            }
        }

        for (let i = 1; i <= 14; i++) {
            let index = `${i}`;
            if (i < 10) {
                index = `0${index}`;
            }
            images.push({
                url: localStorage["mazu_language"] === "en" ?
                      `./assets/imgs/english-svg/g-${index}.svg` :
                      `./assets/imgs/svg/g-${index}.svg`,
                callback: function (response) {
                    let svg = response.getElementsByTagName('svg');
                    let $svg = $(svg);
                    $svg.attr({
                        type: 'image/svg+xml',
                        'class': 'group group-' + i
                    });
                    let actions = $svg.find('image')

                    actions.each(function(index, dom) {
                        const origin_image_name = dom.getAttribute('xlink:href');
                        dom.setAttribute('xlink:href', `${image_prefix}${origin_image_name}`);
                        dom.setAttribute('class', `action action-${index+1}`)
                    });

                    // let $div = $('<div>')
                    //   .append($svg)
                    //   .attr({
                    //     'class': 'group group-' + i
                    //   })
                    //   ;

                    $main_parade.append($svg);
                },
            });
        }

        var eagerLoader = new EagerLoader;

        for (var i = 0; i < eagerLoader.urls.length; i++) {
            var url = eagerLoader.urls[i];
            images.push({
                url: url,
                callback: function(){},
            })
        }

        var appImageLoader = new ImageLoader(images, function(loader){
            var count = loader.loadedImage
            count = Math.ceil(count * 100 / loader.images.length);
            count += '%';
            if (count.length <=2) {
                count = '0' . count;
            }
            $('#intro-frame text').html(count);
        })

        appImageLoader.promise.done(function(){
            $app.hide();
            eagerLoader.convert();
            var height = $('#loading-1')[0].height.animVal.value * 0.60;
            setTimeout(function(){
            for(var i = 0; i < intervals.length; i++) {
                clearInterval(intervals[i]);
            }}, 1000);
            const progressHint = new TimelineMax();
            $('#intro-frame text').remove();
            svgPromise.resolve();
            setTimeout(function(){
                progressHint.to($('#fire-all'), 0.7, {yPercent: -107}, 'c2')
            }, 1500);
            setTimeout(function(){
                $('#loading-2').fadeIn(200)
            }, 2400);
            /*
            var $clickBoard = $('<div>')
            .css({
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: '#ccc',
                opacity: 0,
                'z-index': 9999999999,
            })
            .appendTo(document.body)
            ;
            */

            $('#enter-button').one('click', function(){

                for(var i=0; i < svgs.length; i++) {
                    var svg = svgs[i];
                    svg.target.append(svg.dom);
                }

                (function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];

                    if( localStorage["mazu_language"] === "en" ){
                        $('#container').addClass('english')
                    }

                    if (d.getElementById(id)) return;
                        js = d.createElement(s); js.id = id;
                        js.src = "./assets/js/index.js";
                        fjs.parentNode.insertBefore(js, fjs);
                        js.onload = function() {
                            $intro.fadeOut(function(){
                                $app.fadeIn(function(){
                                    $('.main-parade').show();
                                    $('#main-container').show();
                                });
                                $intro.remove();
                            });
                        }
                    }(document, 'script', 'index-js'));
                ;
            });

            //$clickBoard.click();

            /*
            for (let i = 1; i <= 13; i++ ) {
                setTimeout(function(){
                $('#contents-' + i).click()
                }, i * 1600 + 1200);

            }
            */
        }
    )
});
};


var isLandscape = function() {
    return window.innerHeight <= innerWidth;
}

var enter = () => {
  $('.language-selection').fadeOut(500);
  if (isLandscape()) {
      loading(document);
      ga('send', 'event', 'Position', 'pass', 'loading game')
  } else {
      $(window).resize(function (event) {
          if (isLandscape()) {
              $(window).off('resize');
              loading(document);
              ga('send', 'event', 'Position', 'pass', 'loading game')
          }
      });
  }
}

$("#enter-zh-tw").click( () => {
  localStorage['mazu_language'] = 'zh-tw';
  enter();
});

$("#enter-en").click( () => {
  localStorage['mazu_language'] = 'en';
  enter();
});

// if (isLandscape()) {
//     loading(document);
//     ga('send', 'event', 'Position', 'pass', 'loading game')
// } else {
//     $(window).resize(function (event) {
//         if (isLandscape()) {
//             $(window).off('resize');
//             loading(document);
//             ga('send', 'event', 'Position', 'pass', 'loading game')
//         }
//     });
// }



/** WEBPACK FOOTER **
 ** ./src/intro.js
 **/